export const APP_COUNTRIES = [
    {
        code: "CL",
        label: "Chile",
        flag: "🇨🇱",
        locale: "es-CL",
        timezone: "America/Santiago",
    },
    {
        code: "CO",
        label: "Colombia",
        flag: "🇨🇴",
        locale: "es-CO",
        timezone: "America/Bogota",
    },
    {
        code: "IT",
        label: "Italia",
        flag: "🇮🇹",
        locale: "it-IT",
        timezone: "Europe/Rome",
    },
    {
        code: "GR",
        label: "Grecia",
        flag: "🇬🇷",
        locale: "el-GR",
        timezone: "Europe/Athens",
    },
];
export const DEFAULT_APP_COUNTRY = "CL";
export const regionalConfigForCountry = (countryCode) => {
    const code = String(countryCode || DEFAULT_APP_COUNTRY)
        .trim()
        .toUpperCase();
    const found = APP_COUNTRIES.find((item) => item.code === code);
    if (found) {
        return { code: found.code, locale: found.locale, timezone: found.timezone };
    }
    const fallback = APP_COUNTRIES[0];
    return {
        code: fallback.code,
        locale: fallback.locale,
        timezone: fallback.timezone,
    };
};
export const INSTITUTION_CATEGORIES_UI = [
    { id: "school", label: "Colegio / establecimiento educativo" },
    { id: "sports_club", label: "Club deportivo" },
    { id: "academy", label: "Academia" },
    { id: "scout", label: "Scout / juvenil" },
    { id: "community", label: "Comunidad / barrio" },
    { id: "association", label: "Asociación" },
    { id: "company", label: "Empresa / organización" },
    { id: "other", label: "Otra" },
];
export const INSTITUTION_SEARCH_PLACEHOLDERS = {
    CL: "Ej: Club Deportivo Los Cóndores",
    CO: "Ej: Colegio San José",
    IT: "Ej: Scuola Elementare Roma",
    GR: "Ej: Σχολείο Αθήνας",
};
